/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable max-len */
import React from 'react';

export default function AdorSpinner() {
    function LoadingLogo() {
        return (
            <div>
                <div className="flex justify-center relative login-btn1">

                    {true && (
                        <div className="loader bg-[#FFFFFF] rounded-lg shadow-s2 absolute -top-[138px] left-1/2 -translate-x-1/2 px-7 pt-6 pb-3 min-h-[108px] min-w-[108px]">
                            <lottie-player src="https://assets8.lottiefiles.com/packages/lf20_c0b34ayt.json" class="" background="transparent" speed="1" style={{ width: '58px', height: '58px' }} loop autoplay />
                            <p className="text-sm font-normal text-[#555259] text-center">Loading..</p>
                        </div>
                    )}
                </div>
            </div>
        );
    }
    return (
        (
            <div className="parentDisable" width="100%">
                <div className="overlay-box">
                    <LoadingLogo />
                </div>
            </div>
        )
    );
}
